const DEFAULT_AUTH_ERROR_MESSAGE = 'Something went wrong. Please try again.';

/**
 * Fallback copy for marketing auth toasts when the API returns no message.
 * Server-side auth endpoints sanitize unexpected errors in UsersController.
 */
export const getAuthApiErrorMessage = (message: string | undefined): string => {
  const trimmed = message?.trim();

  if (trimmed) {
    return trimmed;
  }

  return DEFAULT_AUTH_ERROR_MESSAGE;
};
